import { Component, Input } from "@angular/core";

@Component({
  selector: "app-info-badge",
  templateUrl: "./info-badge.component.html",
  styleUrls: ["./info-badge.component.scss"]
})
export class InfoBadgeComponent {
  @Input() title?: string = "Illustrative image. Actual product may vary.";
  @Input() rightJustifying?: false;
}